import {
  button,
  colors,
  fonts,
  tile,
  tileKey,
  tileValue,
} from '../../theme';

const styles = {
  spinner: {
    alignSelf: 'center',
    color: colors.text,
  },
  // Same frame as the player of the admin report: the thumbnail is centered on black.
  preview: {
    width: '100%',
    aspectRatio: '16 / 9',
    borderRadius: '10px',
    backgroundColor: colors.background,
    overflow: 'hidden',
    flexShrink: 0,
  },
  thumb: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 1,
  },
  tile,
  tileKey,
  tileValue,
  reasonCard: {
    ...tile,
    py: 1.5,
    gap: 0.75,
  },
  reason: {
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 700,
    color: colors.text,
  },
  description: {
    fontFamily: fonts.text,
    fontSize: 13.5,
    lineHeight: 1.5,
    color: colors.textSecondary,
  },
  button,
};

export default styles;
